// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YoutubeSchedulerRouteImport } from './routes/youtube-scheduler'
import { Route as XSchedulerRouteImport } from './routes/x-scheduler'
import { Route as WebinarRouteImport } from './routes/webinar'
import { Route as UpgradeSuccessRouteImport } from './routes/upgrade-success'
import { Route as UpgradeErrorRouteImport } from './routes/upgrade-error'
import { Route as TiktokSchedulerRouteImport } from './routes/tiktok-scheduler'
import { Route as ThreadsSchedulerRouteImport } from './routes/threads-scheduler'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PinterestSchedulerRouteImport } from './routes/pinterest-scheduler'
import { Route as OpenclawSocialMediaRouteImport } from './routes/openclaw-social-media'
import { Route as McpServerRouteImport } from './routes/mcp-server'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LinkedinSchedulerRouteImport } from './routes/linkedin-scheduler'
import { Route as InstagramSchedulerRouteImport } from './routes/instagram-scheduler'
import { Route as HelpRouteImport } from './routes/help'
import { Route as GeminiSocialMediaRouteImport } from './routes/gemini-social-media'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FacebookSchedulerRouteImport } from './routes/facebook-scheduler'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CursorSocialMediaRouteImport } from './routes/cursor-social-media'
import { Route as ConnectClaudeRouteImport } from './routes/connect-claude'
import { Route as ConnectChatgptRouteImport } from './routes/connect-chatgpt'
import { Route as CodexSocialMediaRouteImport } from './routes/codex-social-media'
import { Route as CliAuthRouteImport } from './routes/cli-auth'
import { Route as ClaudeSocialMediaRouteImport } from './routes/claude-social-media'
import { Route as ClaudeCodeSocialMediaRouteImport } from './routes/claude-code-social-media'
import { Route as ChooseTrialRouteImport } from './routes/choose-trial'
import { Route as ChoosePlanRouteImport } from './routes/choose-plan'
import { Route as ChatgptSocialMediaRouteImport } from './routes/chatgpt-social-media'
import { Route as BlueskySchedulerRouteImport } from './routes/bluesky-scheduler'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AiSocialMediaAgentRouteImport } from './routes/ai-social-media-agent'
import { Route as AffiliateProgramRouteImport } from './routes/affiliate-program'
import { Route as DocsRouteRouteImport } from './routes/docs/route'
import { Route as BlogRouteRouteImport } from './routes/blog/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentIndexRouteImport } from './routes/agent/index'
import { Route as InvitationsTokenRouteImport } from './routes/invitations/$token'
import { Route as ForFoundersRouteImport } from './routes/for/founders'
import { Route as ForEcommerceRouteImport } from './routes/for/ecommerce'
import { Route as ForCreatorsRouteImport } from './routes/for/creators'
import { Route as ForB2bSaasRouteImport } from './routes/for/b2b-saas'
import { Route as ForAgenciesRouteImport } from './routes/for/agencies'
import { Route as FeaturesTeamApprovalRouteImport } from './routes/features/team-approval'
import { Route as FeaturesCrossPostingRouteImport } from './routes/features/cross-posting'
import { Route as FeaturesCalendarRouteImport } from './routes/features/calendar'
import { Route as FeaturesAiSchedulingRouteImport } from './routes/features/ai-scheduling'
import { Route as DataDeletionCodeRouteImport } from './routes/data-deletion/$code'
import { Route as ChannelsYoutubeRouteImport } from './routes/channels/youtube'
import { Route as ChannelsXRouteImport } from './routes/channels/x'
import { Route as ChannelsTiktokRouteImport } from './routes/channels/tiktok'
import { Route as ChannelsThreadsRouteImport } from './routes/channels/threads'
import { Route as ChannelsPinterestRouteImport } from './routes/channels/pinterest'
import { Route as ChannelsLinkedinRouteImport } from './routes/channels/linkedin'
import { Route as ChannelsInstagramRouteImport } from './routes/channels/instagram'
import { Route as ChannelsFacebookRouteImport } from './routes/channels/facebook'
import { Route as ChannelsBlueskyRouteImport } from './routes/channels/bluesky'
import { Route as AlternativesPostizRouteImport } from './routes/alternatives/postiz'
import { Route as AlternativesHootsuiteRouteImport } from './routes/alternatives/hootsuite'
import { Route as AlternativesBufferRouteImport } from './routes/alternatives/buffer'
import { Route as AgentReviewSocialQueueRouteImport } from './routes/agent/review-social-queue'
import { Route as AgentRepurposeContentRouteImport } from './routes/agent/repurpose-content'
import { Route as AgentPublishApprovedPostsRouteImport } from './routes/agent/publish-approved-posts'
import { Route as AgentLaunchCampaignRouteImport } from './routes/agent/launch-campaign'
import { Route as AgentBuildContentCalendarRouteImport } from './routes/agent/build-content-calendar'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminActivityLogsRouteImport } from './routes/admin/activity-logs'
import { Route as WebinarLiveRouteImport } from './routes/webinar/live'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as HelpSlugRouteImport } from './routes/help/$slug'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSupportRouteImport } from './routes/dashboard/support'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardPostsRouteImport } from './routes/dashboard/posts'
import { Route as DashboardNewWorkspaceRouteImport } from './routes/dashboard/new-workspace'
import { Route as DashboardMembersRouteImport } from './routes/dashboard/members'
import { Route as DashboardMediaRouteImport } from './routes/dashboard/media'
import { Route as DashboardListeningRouteImport } from './routes/dashboard/listening'
import { Route as DashboardConnectRouteImport } from './routes/dashboard/connect'
import { Route as DashboardComposeRouteImport } from './routes/dashboard/compose'
import { Route as DashboardChatRouteImport } from './routes/dashboard/chat'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardBillingRouteImport } from './routes/dashboard/billing'
import { Route as DashboardApiKeysRouteImport } from './routes/dashboard/api-keys'
import { Route as DashboardAnalyticsRouteImport } from './routes/dashboard/analytics'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsSchedulingPostsRouteImport } from './routes/docs/scheduling-posts'
import { Route as DocsRolesRouteImport } from './routes/docs/roles'
import { Route as DocsQuickStartRouteImport } from './routes/docs/quick-start'
import { Route as DocsMcpToolsRouteImport } from './routes/docs/mcp-tools'
import { Route as DocsMcpRouteImport } from './routes/docs/mcp'
import { Route as DocsInvitingMembersRouteImport } from './routes/docs/inviting-members'
import { Route as DocsEditingPostsRouteImport } from './routes/docs/editing-posts'
import { Route as DocsDeletingPostsRouteImport } from './routes/docs/deleting-posts'
import { Route as DocsCreatingPostsRouteImport } from './routes/docs/creating-posts'
import { Route as DocsConnectingAccountsRouteImport } from './routes/docs/connecting-accounts'
import { Route as DocsCalendarRouteImport } from './routes/docs/calendar'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ApiAuthErrorRouteImport } from './routes/api/auth/error'
import { Route as McpConnectBlueskyRouteImport } from './routes/mcp/connect/bluesky'
import { Route as DashboardWorkspacesWorkspaceSlugSettingsRouteImport } from './routes/dashboard/workspaces/$workspaceSlug/settings'

const YoutubeSchedulerRoute = YoutubeSchedulerRouteImport.update({
            id: '/youtube-scheduler',path: '/youtube-scheduler',getParentRoute: () => rootRouteImport
          })
const XSchedulerRoute = XSchedulerRouteImport.update({
            id: '/x-scheduler',path: '/x-scheduler',getParentRoute: () => rootRouteImport
          })
const WebinarRoute = WebinarRouteImport.update({
            id: '/webinar',path: '/webinar',getParentRoute: () => rootRouteImport
          })
const UpgradeSuccessRoute = UpgradeSuccessRouteImport.update({
            id: '/upgrade-success',path: '/upgrade-success',getParentRoute: () => rootRouteImport
          })
const UpgradeErrorRoute = UpgradeErrorRouteImport.update({
            id: '/upgrade-error',path: '/upgrade-error',getParentRoute: () => rootRouteImport
          })
const TiktokSchedulerRoute = TiktokSchedulerRouteImport.update({
            id: '/tiktok-scheduler',path: '/tiktok-scheduler',getParentRoute: () => rootRouteImport
          })
const ThreadsSchedulerRoute = ThreadsSchedulerRouteImport.update({
            id: '/threads-scheduler',path: '/threads-scheduler',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SkillsRoute = SkillsRouteImport.update({
            id: '/skills',path: '/skills',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PinterestSchedulerRoute = PinterestSchedulerRouteImport.update({
            id: '/pinterest-scheduler',path: '/pinterest-scheduler',getParentRoute: () => rootRouteImport
          })
const OpenclawSocialMediaRoute = OpenclawSocialMediaRouteImport.update({
            id: '/openclaw-social-media',path: '/openclaw-social-media',getParentRoute: () => rootRouteImport
          })
const McpServerRoute = McpServerRouteImport.update({
            id: '/mcp-server',path: '/mcp-server',getParentRoute: () => rootRouteImport
          })
const McpRoute = McpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LinkedinSchedulerRoute = LinkedinSchedulerRouteImport.update({
            id: '/linkedin-scheduler',path: '/linkedin-scheduler',getParentRoute: () => rootRouteImport
          })
const InstagramSchedulerRoute = InstagramSchedulerRouteImport.update({
            id: '/instagram-scheduler',path: '/instagram-scheduler',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const GeminiSocialMediaRoute = GeminiSocialMediaRouteImport.update({
            id: '/gemini-social-media',path: '/gemini-social-media',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FacebookSchedulerRoute = FacebookSchedulerRouteImport.update({
            id: '/facebook-scheduler',path: '/facebook-scheduler',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CursorSocialMediaRoute = CursorSocialMediaRouteImport.update({
            id: '/cursor-social-media',path: '/cursor-social-media',getParentRoute: () => rootRouteImport
          })
const ConnectClaudeRoute = ConnectClaudeRouteImport.update({
            id: '/connect-claude',path: '/connect-claude',getParentRoute: () => rootRouteImport
          })
const ConnectChatgptRoute = ConnectChatgptRouteImport.update({
            id: '/connect-chatgpt',path: '/connect-chatgpt',getParentRoute: () => rootRouteImport
          })
const CodexSocialMediaRoute = CodexSocialMediaRouteImport.update({
            id: '/codex-social-media',path: '/codex-social-media',getParentRoute: () => rootRouteImport
          })
const CliAuthRoute = CliAuthRouteImport.update({
            id: '/cli-auth',path: '/cli-auth',getParentRoute: () => rootRouteImport
          })
const ClaudeSocialMediaRoute = ClaudeSocialMediaRouteImport.update({
            id: '/claude-social-media',path: '/claude-social-media',getParentRoute: () => rootRouteImport
          })
const ClaudeCodeSocialMediaRoute = ClaudeCodeSocialMediaRouteImport.update({
            id: '/claude-code-social-media',path: '/claude-code-social-media',getParentRoute: () => rootRouteImport
          })
const ChooseTrialRoute = ChooseTrialRouteImport.update({
            id: '/choose-trial',path: '/choose-trial',getParentRoute: () => rootRouteImport
          })
const ChoosePlanRoute = ChoosePlanRouteImport.update({
            id: '/choose-plan',path: '/choose-plan',getParentRoute: () => rootRouteImport
          })
const ChatgptSocialMediaRoute = ChatgptSocialMediaRouteImport.update({
            id: '/chatgpt-social-media',path: '/chatgpt-social-media',getParentRoute: () => rootRouteImport
          })
const BlueskySchedulerRoute = BlueskySchedulerRouteImport.update({
            id: '/bluesky-scheduler',path: '/bluesky-scheduler',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const ApiKeysRoute = ApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => rootRouteImport
          })
const AiSocialMediaAgentRoute = AiSocialMediaAgentRouteImport.update({
            id: '/ai-social-media-agent',path: '/ai-social-media-agent',getParentRoute: () => rootRouteImport
          })
const AffiliateProgramRoute = AffiliateProgramRouteImport.update({
            id: '/affiliate-program',path: '/affiliate-program',getParentRoute: () => rootRouteImport
          })
const DocsRouteRoute = DocsRouteRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgentIndexRoute = AgentIndexRouteImport.update({
            id: '/agent/',path: '/agent/',getParentRoute: () => rootRouteImport
          })
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
            id: '/invitations/$token',path: '/invitations/$token',getParentRoute: () => rootRouteImport
          })
const ForFoundersRoute = ForFoundersRouteImport.update({
            id: '/for/founders',path: '/for/founders',getParentRoute: () => rootRouteImport
          })
const ForEcommerceRoute = ForEcommerceRouteImport.update({
            id: '/for/ecommerce',path: '/for/ecommerce',getParentRoute: () => rootRouteImport
          })
const ForCreatorsRoute = ForCreatorsRouteImport.update({
            id: '/for/creators',path: '/for/creators',getParentRoute: () => rootRouteImport
          })
const ForB2bSaasRoute = ForB2bSaasRouteImport.update({
            id: '/for/b2b-saas',path: '/for/b2b-saas',getParentRoute: () => rootRouteImport
          })
const ForAgenciesRoute = ForAgenciesRouteImport.update({
            id: '/for/agencies',path: '/for/agencies',getParentRoute: () => rootRouteImport
          })
const FeaturesTeamApprovalRoute = FeaturesTeamApprovalRouteImport.update({
            id: '/features/team-approval',path: '/features/team-approval',getParentRoute: () => rootRouteImport
          })
const FeaturesCrossPostingRoute = FeaturesCrossPostingRouteImport.update({
            id: '/features/cross-posting',path: '/features/cross-posting',getParentRoute: () => rootRouteImport
          })
const FeaturesCalendarRoute = FeaturesCalendarRouteImport.update({
            id: '/features/calendar',path: '/features/calendar',getParentRoute: () => rootRouteImport
          })
const FeaturesAiSchedulingRoute = FeaturesAiSchedulingRouteImport.update({
            id: '/features/ai-scheduling',path: '/features/ai-scheduling',getParentRoute: () => rootRouteImport
          })
const DataDeletionCodeRoute = DataDeletionCodeRouteImport.update({
            id: '/data-deletion/$code',path: '/data-deletion/$code',getParentRoute: () => rootRouteImport
          })
const ChannelsYoutubeRoute = ChannelsYoutubeRouteImport.update({
            id: '/channels/youtube',path: '/channels/youtube',getParentRoute: () => rootRouteImport
          })
const ChannelsXRoute = ChannelsXRouteImport.update({
            id: '/channels/x',path: '/channels/x',getParentRoute: () => rootRouteImport
          })
const ChannelsTiktokRoute = ChannelsTiktokRouteImport.update({
            id: '/channels/tiktok',path: '/channels/tiktok',getParentRoute: () => rootRouteImport
          })
const ChannelsThreadsRoute = ChannelsThreadsRouteImport.update({
            id: '/channels/threads',path: '/channels/threads',getParentRoute: () => rootRouteImport
          })
const ChannelsPinterestRoute = ChannelsPinterestRouteImport.update({
            id: '/channels/pinterest',path: '/channels/pinterest',getParentRoute: () => rootRouteImport
          })
const ChannelsLinkedinRoute = ChannelsLinkedinRouteImport.update({
            id: '/channels/linkedin',path: '/channels/linkedin',getParentRoute: () => rootRouteImport
          })
const ChannelsInstagramRoute = ChannelsInstagramRouteImport.update({
            id: '/channels/instagram',path: '/channels/instagram',getParentRoute: () => rootRouteImport
          })
const ChannelsFacebookRoute = ChannelsFacebookRouteImport.update({
            id: '/channels/facebook',path: '/channels/facebook',getParentRoute: () => rootRouteImport
          })
const ChannelsBlueskyRoute = ChannelsBlueskyRouteImport.update({
            id: '/channels/bluesky',path: '/channels/bluesky',getParentRoute: () => rootRouteImport
          })
const AlternativesPostizRoute = AlternativesPostizRouteImport.update({
            id: '/alternatives/postiz',path: '/alternatives/postiz',getParentRoute: () => rootRouteImport
          })
const AlternativesHootsuiteRoute = AlternativesHootsuiteRouteImport.update({
            id: '/alternatives/hootsuite',path: '/alternatives/hootsuite',getParentRoute: () => rootRouteImport
          })
const AlternativesBufferRoute = AlternativesBufferRouteImport.update({
            id: '/alternatives/buffer',path: '/alternatives/buffer',getParentRoute: () => rootRouteImport
          })
const AgentReviewSocialQueueRoute = AgentReviewSocialQueueRouteImport.update({
            id: '/agent/review-social-queue',path: '/agent/review-social-queue',getParentRoute: () => rootRouteImport
          })
const AgentRepurposeContentRoute = AgentRepurposeContentRouteImport.update({
            id: '/agent/repurpose-content',path: '/agent/repurpose-content',getParentRoute: () => rootRouteImport
          })
const AgentPublishApprovedPostsRoute = AgentPublishApprovedPostsRouteImport.update({
            id: '/agent/publish-approved-posts',path: '/agent/publish-approved-posts',getParentRoute: () => rootRouteImport
          })
const AgentLaunchCampaignRoute = AgentLaunchCampaignRouteImport.update({
            id: '/agent/launch-campaign',path: '/agent/launch-campaign',getParentRoute: () => rootRouteImport
          })
const AgentBuildContentCalendarRoute = AgentBuildContentCalendarRouteImport.update({
            id: '/agent/build-content-calendar',path: '/agent/build-content-calendar',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => rootRouteImport
          })
const AdminActivityLogsRoute = AdminActivityLogsRouteImport.update({
            id: '/admin/activity-logs',path: '/admin/activity-logs',getParentRoute: () => rootRouteImport
          })
const WebinarLiveRoute = WebinarLiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => WebinarRoute
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HelpRoute
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => HelpRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardSupportRoute = DashboardSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => DashboardRoute
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRoute
          })
const DashboardPostsRoute = DashboardPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => DashboardRoute
          })
const DashboardNewWorkspaceRoute = DashboardNewWorkspaceRouteImport.update({
            id: '/new-workspace',path: '/new-workspace',getParentRoute: () => DashboardRoute
          })
const DashboardMembersRoute = DashboardMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => DashboardRoute
          })
const DashboardMediaRoute = DashboardMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => DashboardRoute
          })
const DashboardListeningRoute = DashboardListeningRouteImport.update({
            id: '/listening',path: '/listening',getParentRoute: () => DashboardRoute
          })
const DashboardConnectRoute = DashboardConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => DashboardRoute
          })
const DashboardComposeRoute = DashboardComposeRouteImport.update({
            id: '/compose',path: '/compose',getParentRoute: () => DashboardRoute
          })
const DashboardChatRoute = DashboardChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => DashboardRoute
          })
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => DashboardRoute
          })
const DashboardBillingRoute = DashboardBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardRoute
          })
const DashboardApiKeysRoute = DashboardApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => DashboardRoute
          })
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => DashboardRoute
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRouteRoute
          })
const DocsSchedulingPostsRoute = DocsSchedulingPostsRouteImport.update({
            id: '/scheduling-posts',path: '/scheduling-posts',getParentRoute: () => DocsRouteRoute
          })
const DocsRolesRoute = DocsRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => DocsRouteRoute
          })
const DocsQuickStartRoute = DocsQuickStartRouteImport.update({
            id: '/quick-start',path: '/quick-start',getParentRoute: () => DocsRouteRoute
          })
const DocsMcpToolsRoute = DocsMcpToolsRouteImport.update({
            id: '/mcp-tools',path: '/mcp-tools',getParentRoute: () => DocsRouteRoute
          })
const DocsMcpRoute = DocsMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => DocsRouteRoute
          })
const DocsInvitingMembersRoute = DocsInvitingMembersRouteImport.update({
            id: '/inviting-members',path: '/inviting-members',getParentRoute: () => DocsRouteRoute
          })
const DocsEditingPostsRoute = DocsEditingPostsRouteImport.update({
            id: '/editing-posts',path: '/editing-posts',getParentRoute: () => DocsRouteRoute
          })
const DocsDeletingPostsRoute = DocsDeletingPostsRouteImport.update({
            id: '/deleting-posts',path: '/deleting-posts',getParentRoute: () => DocsRouteRoute
          })
const DocsCreatingPostsRoute = DocsCreatingPostsRouteImport.update({
            id: '/creating-posts',path: '/creating-posts',getParentRoute: () => DocsRouteRoute
          })
const DocsConnectingAccountsRoute = DocsConnectingAccountsRouteImport.update({
            id: '/connecting-accounts',path: '/connecting-accounts',getParentRoute: () => DocsRouteRoute
          })
const DocsCalendarRoute = DocsCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => DocsRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRouteRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRouteRoute
          })
const ApiAuthErrorRoute = ApiAuthErrorRouteImport.update({
            id: '/api/auth/error',path: '/api/auth/error',getParentRoute: () => rootRouteImport
          })
const McpConnectBlueskyRoute = McpConnectBlueskyRouteImport.update({
            id: '/connect/bluesky',path: '/connect/bluesky',getParentRoute: () => McpRoute
          })
const DashboardWorkspacesWorkspaceSlugSettingsRoute = DashboardWorkspacesWorkspaceSlugSettingsRouteImport.update({
            id: '/workspaces/$workspaceSlug/settings',path: '/workspaces/$workspaceSlug/settings',getParentRoute: () => DashboardRoute
          })





const BlogRouteRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)




const DocsRouteRouteChildren = {
  DocsCalendarRoute: DocsCalendarRoute,DocsConnectingAccountsRoute: DocsConnectingAccountsRoute,DocsCreatingPostsRoute: DocsCreatingPostsRoute,DocsDeletingPostsRoute: DocsDeletingPostsRoute,DocsEditingPostsRoute: DocsEditingPostsRoute,DocsInvitingMembersRoute: DocsInvitingMembersRoute,DocsMcpRoute: DocsMcpRoute,DocsMcpToolsRoute: DocsMcpToolsRoute,DocsQuickStartRoute: DocsQuickStartRoute,DocsRolesRoute: DocsRolesRoute,DocsSchedulingPostsRoute: DocsSchedulingPostsRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(DocsRouteRouteChildren)




const DashboardRouteChildren = {
  DashboardAnalyticsRoute: DashboardAnalyticsRoute,DashboardApiKeysRoute: DashboardApiKeysRoute,DashboardBillingRoute: DashboardBillingRoute,DashboardCalendarRoute: DashboardCalendarRoute,DashboardChatRoute: DashboardChatRoute,DashboardComposeRoute: DashboardComposeRoute,DashboardConnectRoute: DashboardConnectRoute,DashboardListeningRoute: DashboardListeningRoute,DashboardMediaRoute: DashboardMediaRoute,DashboardMembersRoute: DashboardMembersRoute,DashboardNewWorkspaceRoute: DashboardNewWorkspaceRoute,DashboardPostsRoute: DashboardPostsRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardSupportRoute: DashboardSupportRoute,DashboardIndexRoute: DashboardIndexRoute,DashboardWorkspacesWorkspaceSlugSettingsRoute: DashboardWorkspacesWorkspaceSlugSettingsRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const HelpRouteChildren = {
  HelpSlugRoute: HelpSlugRoute,HelpIndexRoute: HelpIndexRoute
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)




const McpRouteChildren = {
  McpConnectBlueskyRoute: McpConnectBlueskyRoute
}

const McpRouteWithChildren = McpRoute._addFileChildren(McpRouteChildren)




const WebinarRouteChildren = {
  WebinarLiveRoute: WebinarLiveRoute
}

const WebinarRouteWithChildren = WebinarRoute._addFileChildren(WebinarRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRouteRoute: BlogRouteRouteWithChildren,DocsRouteRoute: DocsRouteRouteWithChildren,AffiliateProgramRoute: AffiliateProgramRoute,AiSocialMediaAgentRoute: AiSocialMediaAgentRoute,ApiKeysRoute: ApiKeysRoute,BillingRoute: BillingRoute,BlueskySchedulerRoute: BlueskySchedulerRoute,ChatgptSocialMediaRoute: ChatgptSocialMediaRoute,ChoosePlanRoute: ChoosePlanRoute,ChooseTrialRoute: ChooseTrialRoute,ClaudeCodeSocialMediaRoute: ClaudeCodeSocialMediaRoute,ClaudeSocialMediaRoute: ClaudeSocialMediaRoute,CliAuthRoute: CliAuthRoute,CodexSocialMediaRoute: CodexSocialMediaRoute,ConnectChatgptRoute: ConnectChatgptRoute,ConnectClaudeRoute: ConnectClaudeRoute,CursorSocialMediaRoute: CursorSocialMediaRoute,DashboardRoute: DashboardRouteWithChildren,FacebookSchedulerRoute: FacebookSchedulerRoute,ForgotPasswordRoute: ForgotPasswordRoute,GeminiSocialMediaRoute: GeminiSocialMediaRoute,HelpRoute: HelpRouteWithChildren,InstagramSchedulerRoute: InstagramSchedulerRoute,LinkedinSchedulerRoute: LinkedinSchedulerRoute,LoginRoute: LoginRoute,McpRoute: McpRouteWithChildren,McpServerRoute: McpServerRoute,OpenclawSocialMediaRoute: OpenclawSocialMediaRoute,PinterestSchedulerRoute: PinterestSchedulerRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,SkillsRoute: SkillsRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,ThreadsSchedulerRoute: ThreadsSchedulerRoute,TiktokSchedulerRoute: TiktokSchedulerRoute,UpgradeErrorRoute: UpgradeErrorRoute,UpgradeSuccessRoute: UpgradeSuccessRoute,WebinarRoute: WebinarRouteWithChildren,XSchedulerRoute: XSchedulerRoute,YoutubeSchedulerRoute: YoutubeSchedulerRoute,AdminActivityLogsRoute: AdminActivityLogsRoute,AdminFeedbackRoute: AdminFeedbackRoute,AdminUsersRoute: AdminUsersRoute,AgentBuildContentCalendarRoute: AgentBuildContentCalendarRoute,AgentLaunchCampaignRoute: AgentLaunchCampaignRoute,AgentPublishApprovedPostsRoute: AgentPublishApprovedPostsRoute,AgentRepurposeContentRoute: AgentRepurposeContentRoute,AgentReviewSocialQueueRoute: AgentReviewSocialQueueRoute,AlternativesBufferRoute: AlternativesBufferRoute,AlternativesHootsuiteRoute: AlternativesHootsuiteRoute,AlternativesPostizRoute: AlternativesPostizRoute,ChannelsBlueskyRoute: ChannelsBlueskyRoute,ChannelsFacebookRoute: ChannelsFacebookRoute,ChannelsInstagramRoute: ChannelsInstagramRoute,ChannelsLinkedinRoute: ChannelsLinkedinRoute,ChannelsPinterestRoute: ChannelsPinterestRoute,ChannelsThreadsRoute: ChannelsThreadsRoute,ChannelsTiktokRoute: ChannelsTiktokRoute,ChannelsXRoute: ChannelsXRoute,ChannelsYoutubeRoute: ChannelsYoutubeRoute,DataDeletionCodeRoute: DataDeletionCodeRoute,FeaturesAiSchedulingRoute: FeaturesAiSchedulingRoute,FeaturesCalendarRoute: FeaturesCalendarRoute,FeaturesCrossPostingRoute: FeaturesCrossPostingRoute,FeaturesTeamApprovalRoute: FeaturesTeamApprovalRoute,ForAgenciesRoute: ForAgenciesRoute,ForB2bSaasRoute: ForB2bSaasRoute,ForCreatorsRoute: ForCreatorsRoute,ForEcommerceRoute: ForEcommerceRoute,ForFoundersRoute: ForFoundersRoute,InvitationsTokenRoute: InvitationsTokenRoute,AgentIndexRoute: AgentIndexRoute,ApiAuthErrorRoute: ApiAuthErrorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)